import { resizeObservers as f } from "./highrise1820.mjs";
import { ResizeObserverEntry as p } from "./highrise1746.mjs";
import { calculateDepthForNode as g } from "./highrise1848.mjs";
import { calculateBoxSize as b } from "./highrise1391.mjs";
var T = function() {
  var t = 1 / 0, s = [];
  f.forEach(function(e) {
    if (e.activeTargets.length !== 0) {
      var i = [];
      e.activeTargets.forEach(function(r) {
        var l = new p(r.target), v = g(r.target);
        i.push(l), r.lastReportedSize = b(r.target, r.observedBox), v < t && (t = v);
      }), s.push(function() {
        e.callback.call(e.observer, i, e.observer);
      }), e.activeTargets.splice(0, e.activeTargets.length);
    }
  });
  for (var a = 0, c = s; a < c.length; a++) {
    var n = c[a];
    n();
  }
  return t;
};
export {
  T as broadcastActiveObservations
};
